import { UUID } from '@/types/Id'

interface WordTemplatesQueryKeyArgs {
  orgId: UUID | ''
}

interface WordTemplateQueryKeyArgs {
  wordTemplateId: UUID | ''
}

export const wordTemplatesQueryKeys = {
  all: () => ['word-template'] as const,
  organization: (keyArgs: WordTemplatesQueryKeyArgs) =>
    ['word-templates', keyArgs.orgId] as const,
  wordTemplate: (keyArgs: WordTemplateQueryKeyArgs) =>
    ['word-template', keyArgs.wordTemplateId] as const,
  count: (keyArgs: WordTemplatesQueryKeyArgs) =>
    ['word-templates', keyArgs.orgId, 'count'] as const,
}
